module.exports = __webpack_public_path__ + "static/media/image_1.3643136c.jpg";